import { PrescriptionsSearch } from "../types";

export const urls = {
  prescriptions: () => "/api/client/v1/prescriptions/list/",
};

export const keys = {
  all: () => ["prescriptions-all"],
  prescriptions: () => [...keys.all(), "prescriptions"],
  prescriptionLists: () => [...keys.prescriptions(), "list"],
  prescriptionList: (search: PrescriptionsSearch) => [...keys.prescriptionLists(), search],
};
